module.exports = __webpack_public_path__ + "img/Angiogenesis-LICA_GSE236681.dd2b4306.png";